import { TableCell, TableRow } from "@material-ui/core";
import { memo } from "react";
import { xlsxGroupEmptyDescription } from "../../../constants";

const GroupHeaderTableRow = ({ cell, columns }) => {
  return (
    <TableRow>
      <TableCell
        align="left"
        colSpan={columns.length}
        style={{ backgroundColor: "#eaf2ff" }}
      >
        {cell.group?.description ?? xlsxGroupEmptyDescription[cell.group?.type]}
      </TableCell>
    </TableRow>
  );
};

export default memo(GroupHeaderTableRow);
